import { render, staticRenderFns } from "./CdkNewsItemDetail.vue?vue&type=template&id=5308d53d&"
import script from "./CdkNewsItemDetail.vue?vue&type=script&lang=ts&"
export * from "./CdkNewsItemDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CdkNewsItemDetail.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VLayout})
